import React from 'react';
import { FileText, ShieldCheck, CheckCircle2 } from 'lucide-react';
import { Card, Badge } from '../ui';
import { companyInfo } from '../../data/company';

export const TermsSection: React.FC = () => {
  return (
    <section className="py-24 relative min-h-screen bg-white dark:bg-[#080e1a]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
        <div className="text-center space-y-3">
          <Badge variant="brand" className="px-3.5 py-1 text-xs uppercase tracking-wider">
            <FileText size={14} /> Service Terms & Agreements
          </Badge>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-[#184166] dark:text-white tracking-tight">
            Terms of Service
          </h1>
          <p className="text-xs text-slate-500 dark:text-slate-400">
            Technook Global Master Enterprise Service Terms
          </p>
        </div>

        <Card variant="glass" className="p-8 sm:p-10 space-y-8 text-slate-700 dark:text-slate-300 text-sm leading-relaxed bg-[#f5f9fc] dark:bg-[#0f1b2d] border border-slate-200 dark:border-slate-800">
          <div className="space-y-3">
            <h3 className="text-lg font-bold text-[#184166] dark:text-white flex items-center gap-2 border-b border-slate-200 dark:border-slate-800 pb-2">
              <ShieldCheck size={18} className="text-[#4a82c2]" /> 1. Agreement Framework
            </h3>
            <p>
              By accessing the website or engaging services provided by Technook Global (&quot;Technook&quot;), you agree to be bound by these Master Terms of Service. Services include Software & System Development, Marketing & Brand Support, Lead Generation & Sales Support, and Admin & Operation Support.
            </p>
          </div>

          <div className="space-y-3">
            <h3 className="text-lg font-bold text-[#184166] dark:text-white flex items-center gap-2 border-b border-slate-200 dark:border-slate-800 pb-2">
              <CheckCircle2 size={18} className="text-[#08adae]" /> 2. Project Scopes & Delivery SLAs
            </h3>
            <p>
              All technical work, deliverables, milestones, and acceptances are governed by individual Statements of Work (SOW) or RFP agreements executed between Technook and the Client.
            </p>
            <ul className="space-y-1.5 pl-4 text-xs text-slate-600 dark:text-slate-400">
              <li>• Development deliverables undergo automated QA and milestone sign-off prior to production deployment.</li>
              <li>• SLA guarantees (e.g. 99.9% uptime for cloud hosting) are specified in project-specific contracts.</li>
            </ul>
          </div>

          <div className="space-y-3">
            <h3 className="text-lg font-bold text-[#184166] dark:text-white flex items-center gap-2 border-b border-slate-200 dark:border-slate-800 pb-2">
              <ShieldCheck size={18} className="text-emerald-500" /> 3. Intellectual Property Rights
            </h3>
            <p>
              Upon full payment of agreed fees, all custom code, application software, design assets, and documentation engineered specifically for the Client shall belong exclusively to the Client, subject to standard open-source framework licenses.
            </p>
          </div>

          <div className="space-y-3">
            <h3 className="text-lg font-bold text-[#184166] dark:text-white flex items-center gap-2 border-b border-slate-200 dark:border-slate-800 pb-2">
              <FileText size={18} className="text-amber-500" /> 4. Contact & Inquiries
            </h3>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              For questions regarding enterprise service terms, contact <span className="text-[#4a82c2] font-mono">{companyInfo.email}</span> or visit our office at Imperial Plaza, Diosdado Macapagal Blvd., Parañaque City.
            </p>
          </div>
        </Card>
      </div>
    </section>
  );
};
